import { render, staticRenderFns } from "./PropostaAcoes.vue?vue&type=template&id=eb1e14ac"
import script from "./PropostaAcoes.vue?vue&type=script&lang=js"
export * from "./PropostaAcoes.vue?vue&type=script&lang=js"
import style0 from "./PropostaAcoes.vue?vue&type=style&index=0&id=eb1e14ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports